export default "__VITE_ASSET__Dap6VcOi__"